export default __webpack_public_path__ + "static/media/bg-net.dc39b1b6.png";